import { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import get from 'lodash/get';
import PropTypes from 'prop-types';
import { change } from 'redux-form';

import { Box } from '@mui/material';

import { useTransl } from 'shared/lib/i18n';

import CreateDeliveryFormContainer from './CreateDeliveryFormContainer';

import {
  getBuildingUnits,
  getPeopleInBuilding,
} from '../Building/actionCreators';
import { getBuildingDeliveryTypes } from '../DeliveryTypes/actions';

import { filterObjectByKeyValue, getSelectValue } from '../../utils';
import { buildingsForFilterTypes } from '../Shared/utils/types';

import { deliveryFormName as form } from './constants';

import StyledSelect from '../Select';

const CreateDeliveryContainer = ({
  selectOptions,
  unitOptions,
  buildings,
  getBuildingUnits,
  onGetPeopleInBuilding,
  getBuildingDeliveryTypes,
  onModalClose,
  onFieldChange,
}) => {
  const { t } = useTransl();

  const [selectValue, setSelectValue] = useState(null);
  const buildingId = selectValue && selectValue.value;
  const building = buildingId && buildings[buildingId];
  const recipients = building && building.people;
  const deliveryTypes =
    building?.deliveryTypes?.filter(({ enabled }) => enabled) ?? [];

  useEffect(() => {
    if (!selectValue && selectOptions?.length) {
      setSelectValue(selectOptions[0]);
    }
  }, [selectOptions]);

  useEffect(() => {
    if (selectValue?.value) {
      onGetPeopleInBuilding(selectValue.value);
      getBuildingUnits(selectValue.value);
      getBuildingDeliveryTypes(selectValue.value);
      onFieldChange('units', []);
      onFieldChange('recipients', []);
    }
  }, [selectValue]);

  return (
    <>
      {selectOptions.length > 1 ? (
        <>
          <div>{t('title.building')}</div>
          <StyledSelect
            value={getSelectValue(selectValue, selectOptions)}
            onChange={(event, option) => setSelectValue(option)}
            options={selectOptions}
            disableClearable
          />
        </>
      ) : null}

      {building ? (
        <Box mt={selectOptions.length > 1 ? 0 : '-2rem'}>
          <CreateDeliveryFormContainer
            building={building}
            deliveryTypes={deliveryTypes}
            recipients={recipients}
            units={unitOptions}
            onModalClose={onModalClose}
          />
        </Box>
      ) : null}
    </>
  );
};

CreateDeliveryContainer.propTypes = {
  selectOptions: PropTypes.instanceOf(Array).isRequired,
  buildings: buildingsForFilterTypes.isRequired,
  getBuildingUnits: PropTypes.func.isRequired,
  onGetPeopleInBuilding: PropTypes.func.isRequired,
  getBuildingDeliveryTypes: PropTypes.func.isRequired,
  onModalClose: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  unitOptions: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = (state, { frontDeskBuildingId }) => {
  const { buildings, units, lists } = state;
  const selectedBuildingId = get(lists, 'deliveries.building');
  const selectedPMCId = get(lists, 'deliveries.pmc');

  let filteredBuildings = buildings;
  if (selectedBuildingId) {
    filteredBuildings = { [selectedBuildingId]: buildings[selectedBuildingId] };
  }
  if (selectedPMCId) {
    filteredBuildings = filterObjectByKeyValue(
      buildings,
      'parent.id',
      Number(selectedPMCId),
    );
  }

  const selectOptions = [];
  if (frontDeskBuildingId) {
    selectOptions.push({ label: '', value: frontDeskBuildingId });
  } else {
    Object.keys(filteredBuildings).forEach((id) =>
      selectOptions.push({ label: filteredBuildings[id].name, value: id }),
    );
  }

  const unitOptions = [];
  Object.keys(units).forEach((id) => unitOptions.push(units[id]));

  return {
    buildings,
    selectOptions,
    unitOptions,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getBuildingUnits: (buildingId) => getBuildingUnits(dispatch, {}, buildingId),
  onGetPeopleInBuilding: (buildingId) =>
    getPeopleInBuilding(dispatch, buildingId),
  getBuildingDeliveryTypes: (buildingId) =>
    getBuildingDeliveryTypes(dispatch, buildingId, {
      disable_pagination: true,
    }),
  onFieldChange: (field, value) => dispatch(change(form, field, value)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateDeliveryContainer);
